
import React from 'react';
import { FormField } from '@/components/ui/form';
import IconInput from '@/components/auth/IconInput';
import { User, Mail } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

interface PersonalInfoFieldsProps {
  form: UseFormReturn<SaasSignupFormValues & { captcha: string }>;
}

const PersonalInfoFields = ({ form }: PersonalInfoFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <IconInput
            name="name"
            label="Full Name"
            placeholder="Enter your full name"
            icon={User}
            field={field}
          />
        )}
      />
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <IconInput
            name="email"
            label="Email"
            placeholder="Enter your email"
            icon={Mail}
            field={field}
          />
        )}
      />
    </div>
  );
};

export default PersonalInfoFields;
